var map = {
	"./dark": 403,
	"./dark/": 403,
	"./dark/index": 403,
	"./dark/index.js": 403,
	"./light": 404,
	"./light/": 404,
	"./light/index": 404,
	"./light/index.js": 404,
	"./manifest": 276,
	"./manifest.js": 276,
	"./opn": 405,
	"./opn/": 405,
	"./opn/index": 405,
	"./opn/index.js": 405,
	"./regenimo": 406,
	"./regenimo/": 406,
	"./regenimo/index": 406,
	"./regenimo/index.js": 406
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1308;